import { render, staticRenderFns } from "./purchaseReturnRedAction.vue?vue&type=template&id=83f35a9a&scoped=true"
import script from "./purchaseReturnRedAction.vue?vue&type=script&lang=js"
export * from "./purchaseReturnRedAction.vue?vue&type=script&lang=js"
import style0 from "./purchaseReturnRedAction.vue?vue&type=style&index=0&id=83f35a9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f35a9a",
  null
  
)

export default component.exports